const types = {
  SET_COMMENTS: 'SET_COMMENTS',
}

export default types
